const StringUtils = {

    isEmpty: (str: string) => {
        return str === null || str === undefined || str === '';
    },

    splitName: (fullName: string) => {
        const hyphenated = ['欧阳', '太史', '端木', '上官', '司马', '东方', '独孤', '南宫', '万俟', '闻人', '夏侯', '诸葛', '尉迟', '公羊', '赫连', '澹台', '皇甫',
            '宗政', '濮阳', '公冶', '太叔', '申屠', '公孙', '慕容', '仲孙', '钟离', '长孙', '宇文', '城池', '司徒', '鲜于', '司空', '汝嫣', '闾丘', '子车', '亓官',
            '司寇', '巫马', '公西', '颛孙', '壤驷', '公良', '漆雕', '乐正', '宰父', '谷梁', '拓跋', '夹谷', '轩辕', '令狐', '段干', '百里', '呼延', '东郭', '南门',
            '羊舌', '微生', '公户', '公玉', '公仪', '梁丘', '公仲', '公上', '公门', '公山', '公坚', '左丘', '公伯', '西门', '公祖', '第五', '公乘', '贯丘', '公皙',
            '南荣', '东里', '东宫', '仲长', '子书', '子桑', '即墨', '达奚', '褚师'];
        const vLength = fullName.length;
        let lastName = '', firstName = '';//前为姓,后为名

        const splitNames = fullName.split(" ");
        if (splitNames.length >= 2) {
            lastName = splitNames[0];
            firstName = fullName.substr(fullName.indexOf(" "));
        } else {

            if (vLength > 2) {
                const preTwoWords = fullName.substr(0, 2);//取命名的前两个字,看是否在复姓库中
                if (hyphenated.indexOf(preTwoWords) > -1) {
                    lastName = preTwoWords;
                    firstName = fullName.substr(2);
                } else {
                    lastName = fullName.substr(0, 1);
                    firstName = fullName.substr(1);
                }
            } else if (vLength === 2) {//全名只有两个字时,以前一个为姓,后一下为名
                lastName = fullName.substr(0, 1);
                firstName = fullName.substr(1);
            } else {
                lastName = fullName;
            }
        }
        return [lastName, firstName];
    },

    mobileHiding: (mobile: string) => {
        if (mobile) {
            return mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
        }
    },

    idNumberHiding: (idNumber: string) => {
        if (idNumber) {
            return idNumber.replace(/^(.{3})(?:\d+)(.{3})$/, "$1**********$2");
        }
    },

    printIdNumberHiding: (idNumber: string) => {
        if (idNumber) {
            if (idNumber.length === 18) {
                // 如果是第二代身份证，脱敏处理
                return idNumber.substring(0, 1) + "******" + idNumber.substring(6, 12) + "*****" + idNumber.substring(17, 18);
            } else if (idNumber.length === 9) {
                // 如果是中国护照，保留前后一位字符
                return idNumber.substring(0, 1) + "*******" + idNumber.substring(8);
            } else if (idNumber.length === 11) {
                // 如果是港澳通行证，保留前后一位字符
                return idNumber.substring(0, 1) + "*********" + idNumber.substring(11);
            } else {
                // 如果是其他类型的证件号码，保留前后一位字符
                if (idNumber.length > 0) {
                    return idNumber.substring(0, 1) + "*******" + idNumber.substring(idNumber.length - 1);
                } else {
                    return idNumber;
                }
            }
        } else {
            return "";
        }
    },

    formatTime: (time: string | undefined) => {
        if (time && time.length >= 6) {
            const hour = time.substring(0, 2);
            const minute = time.substring(2, 4);
            const seconds = time.substring(4, 6);
            return hour + ":" + minute + ":" + seconds;
        } else {
            return "";
        }
    },

    formatDate: (date: string | undefined) => {
        if (date && date.length >= 8) {
            const year = date.substring(0, 4);
            const month = date.substring(4, 6);
            const day = date.substring(6, 8);
            return year + "-" + month + "-" + day;
        } else {
            return "";
        }
    },

    formatDateTime: (dateTime: string | undefined) => {
        if (dateTime && dateTime.length >= 8) {
            const year = dateTime.substring(0, 4);
            const month = dateTime.substring(4, 6);
            const day = dateTime.substring(6, 8);
            const hour = dateTime.substring(8, 10);
            const minute = dateTime.substring(10, 12);
            const seconds = dateTime.substring(12, 14);
            return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + seconds;
        } else {
            return "";
        }
    },

    maskName: (name: string, maskChar = '*') => {
        if (StringUtils.isEmpty(name)) {
            return ""
        } else {
            let maskedName = name;
            const start = Math.ceil(name.length / 2 - 1);
            const end = Math.floor(name.length / 2 + 1);
            maskedName = name.substring(0, start) + maskChar.repeat(end - start) + name.substring(name.length - 1);
            return maskedName;
        }
    }
};

export default StringUtils;